module.exports = "/img/about-gallery-2.02888b4d.png";